import * as React from "react";
const _ = require('lodash');
export default class StoreProductList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { products, store } = this.props;
        let productList = products.map((product, index) => {
            let selected = _.find(store, { DisplaySKU: product.DisplaySKU });
            return React.createElement("div", { className: selected ? "section selected" : "section unselected", key: index },
                React.createElement("span", { className: "section-product-desc" },
                    React.createElement("i", { className: selected ? "fa fa-check" : "fa fa-times" }),
                    product.Name.toLowerCase()));
        });
        return (React.createElement("div", { className: "store-product-list" },
            React.createElement("div", { className: "section warning" },
                React.createElement("span", null, "Please contact the store to confirm availability.")),
            productList));
    }
}
;
//# sourceMappingURL=store-product-list.js.map